import type { GlossaryItem } from '@features/glossary/domain/glossary';
import { SHARED_GLOSSARY } from '@features/glossary/domain/shared-glossary';

export const GLOSSARY = {
  adSpend: SHARED_GLOSSARY.adSpend,
  attributionMetrics: {
    label: 'Attribution Metrics',
    definition:
      'Sales measurement related to exposed users matched to category-based control, that can be attributed to the effects of advertising. Attribution metrics include Incremental Lift and Incremental Sales.',
  },
  campaignEndDate: SHARED_GLOSSARY.campaignEndDate,
  campaignStartDate: SHARED_GLOSSARY.campaignStartDate,
  confidenceLevel: SHARED_GLOSSARY.confidenceLevel,
  dimension: SHARED_GLOSSARY.dimension,
  dimensionValue: SHARED_GLOSSARY.dimensionValue,
  flightDates: SHARED_GLOSSARY.flightDates,
  impression: SHARED_GLOSSARY.impression,
  incrementalReturnOnAdSpend: SHARED_GLOSSARY.incrementalReturnOnAdSpend,
  incrementalSales: {
    label: 'Incremental Sales',
    definition:
      'Sales Attribution related to exposed users matched to an unexposed control group, can thereby be attributed to the effects of advertising. Measures the additional dollars gained in-store and online due to increased sales.',
  },
  incrementalSalesLift: {
    label: 'Incremental Sales Lift',
    definition:
      'Measures the percentage increase in lift in the incremental sales of the exposed compared to the control.',
  },
  measurementEndDate: {
    label: 'Measurement End Date',
    definition:
      'The date through which impression and sales data are used for a measurement report. This date is the same as the Report Date.',
  },
  measurementPeriod: {
    label: 'Measurement Period',
    definition:
      'The range of days for which impression and sales data are included in a campaign measurement report, from the measurement start date to the end of the measurement end date.',
  },
  measurementStartDate: SHARED_GLOSSARY.measurementStartDate,
  multiTouchAttribution: SHARED_GLOSSARY.multiTouchAttribution,
  penetration: SHARED_GLOSSARY.penetration,
  penetrationLift: {
    label: 'Penetration Lift',
    definition:
      'Measures the percentage increase in lift in the Penetration by the exposed compared to the control.',
  },
  postCampaignMeasurementPeriod: {
    label: 'Post-Campaign Measurement Period',
    definition:
      'The period after the Campaign End Date used to observe sales data. In a standard campaign, this period is 14 days, this is determined by the attribution window.',
  },
  returnOnAdSpend: SHARED_GLOSSARY.returnOnAdSpend,
  salesRate: SHARED_GLOSSARY.salesRate,
  totalProjectedSales: {
    label: 'Total Projected Sales',
    definition:
      'The total post-exposure sales by a set of unique users during a specified time period. This includes in-store and e-commerce (online) sales.',
  },
  transactionRate: SHARED_GLOSSARY.transactionRate,
  transactionRateLift: {
    label: 'Transaction Rate Lift',
    definition:
      'Measures the percentage increase in lift in the Transaction Rate by the exposed compared to the control.',
  },
  transactionSize: {
    label: 'Transaction Size',
    definition: 'The average dollar per purchase during the measurement period',
  },
  transactionSizeLift: {
    label: 'Transaction Size Lift',
    definition:
      'Measures the percentage increase in lift in the Transaction Size by the exposed compared to the control.',
  },
  uniqueUser: SHARED_GLOSSARY.uniqueUser,
  usersMatchedForAttribution: {
    label: 'Users Matched For Attribution',
    definition:
      'Exposed users that have been matched to our sales universe to calculate Incremental Lift.',
  },
} as const satisfies Record<string, GlossaryItem>;
